import { Typography } from '@mui/material';
import type { TypographyProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import parse from 'html-react-parser';

export type PpMarkdownTypography = TypographyProps & {
  highlight?: string;
};

const StyledTypography = styled(Typography)<PpMarkdownTypography>(({ highlight, theme }) => ({
  '.highlight': {
    color: highlight || theme.palette.websiteBrand.primary,
  },
}));

export function MarkdownTypography({
  children,
  highlight,
  ...props
}: PpMarkdownTypography): React.ReactElement | null {
  if (typeof children !== 'string') {
    return null;
  }
  return (
    <StyledTypography highlight={highlight} {...props}>
      {parse(children)}
    </StyledTypography>
  );
}
